import type { ToastState } from '@/hooks/useToast';

type ToastProps = {
  toast: ToastState;
};

export default function Toast({ toast }: ToastProps) {
  return (
    <div
      className={`fixed left-1/2 bottom-8 z-[100] -translate-x-1/2 transition-all duration-300 ${
        toast.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      role="status"
      aria-live="polite"
    >
      <div
        className={`flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium text-background-50 ${
          toast.tone === 'accent' ? 'bg-accent-600' : 'bg-foreground-900'
        }`}
      >
        <i className={`${toast.tone === 'accent' ? 'ri-heart-3-fill' : 'ri-checkbox-circle-fill'} text-base`}></i>
        <span>{toast.message}</span>
      </div>
    </div>
  );
}